import { Injectable, computed, inject, signal } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { of } from 'rxjs';

import {
  ListingDataSource,
  ListingFiltersSource,
  ListingPageModel
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';

import { ReportsService } from '../../services/reports.service';
import { ReportsTable } from '../../reports.types';
import { SEARCH_TYPES, reportsTableConfig, reportsTableSortField } from './reports-list.constants';

@Injectable({ providedIn: 'root' })
export class ReportsListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  private readonly reportsService = inject(ReportsService);
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly exportButtonVisible = false;
  readonly columnsButtonVisible = false;
  readonly pageTitle = TranslateRegistry.get.REPORTS.TITLE.REPORTS;
  readonly searchTypeList = computed(() => SEARCH_TYPES);
  readonly selectedSearchType = computed(() => SEARCH_TYPES[0]);
  readonly sortField = reportsTableSortField;
  readonly sorting = computed(() => ({
    columnName: reportsTableSortField['title'],
    orderDirection: OrderDirection.ASC
  }));
  readonly tableColumns = signal<TableColumn[]>(reportsTableConfig);
  readonly dataSource: ListingDataSource<ReportsTable> = {
    getAll: tableState => this.reportsService.getTableData(tableState),
    total: 0
  };
  readonly tableCmp = ListingTableComponent;
  readonly pageId = ListingPageId.Reports;
  readonly filterSource: ListingFiltersSource = {
    getAll: () => of([]),
    getReportGroup: () => of()
  };

  constructor() {
    super();
    this.listingPageModelRegistry.add(this.pageId, this);
  }
}
